function monitorPersonalizar() {
  const container = document.querySelector("#aparecer");
  if (!container) return;

  // No tema Dawn, os seletores podem ser select ou radio buttons
  const selects = document.querySelectorAll('select.select__select, fieldset.product-form__input input[type="radio"]');
  
  let isPersonalizar = false;

  selects.forEach(el => {
    let val = "";
    if (el.tagName === 'SELECT') {
      val = el.value.trim().toLowerCase();
    } else if (el.checked) {
      val = el.value.trim().toLowerCase();
    }

    // Verifica se o valor é "personalizar"
    if (val === "customize" || val === "personalizar" || val === "personalización") {
      isPersonalizar = true;
    }
  });

  if (isPersonalizar) {
    container.style.display = "block";
    container.classList.remove("removeContainerPersonalizar");
    console.log("Ativando personalização!");
  } else {
    container.style.display = "none";
    container.classList.add("removeContainerPersonalizar");
  }
}

// Monitora mudanças no formulário do produto
const productForm = document.querySelector('.product-form') || document.body;
if (productForm) {
  productForm.addEventListener('change', monitorPersonalizar);
}

// SOLUÇÃO: Executa a função imediatamente ao carregar o script 
// para aplicar o estado correto (visível ou oculto) na primeira visualização da página.
monitorPersonalizar();

// Caso o script esteja carregando antes do HTML, você pode envolver a chamada inicial assim:
// document.addEventListener('DOMContentLoaded', monitorPersonalizar);